import JSBI from 'jsbi'

// exports for external consumption
export type BigintIsh = JSBI | bigint | string

export enum ChainId {
  MAINNET = 56,
  BSCTESTNET = 97
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT
}

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP
}

// follow come: factory - 0x6725f303b657a9451d8ba641348b6761a6cc7a17
// init code follow come - 0xd0d4c4cd0848c93cb4fd1f498d7013ee6bfb25783ea21593d5834f5d250ece66
// mainnet deployed factory - 
// mainnet deployed router - 
// mainnet init code - 

// v2 pancakeswap factory: 0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73
// v2 init_hash_code pancakeswap: 0x00fb7f630766e6a796048ea87d01acd3068e8ff67d078148a3fa3f4a84f69bd5

// v2 testnet factory and init hash: 0x7E6FC3DC3b1c9b5779172f80566e41b661Dd76e1 & 
//                                   0x45feff76f2af8973c5d048c3039c1324cd3ddcab8b15623f31675789eb002438

//v2 bsc mainnet chickenswap factory and init : 0xD4F22fE9416801F920b20E9cb2381a8c5bf5650F
//                                              0x94303c880d15738ecf88f404a8cab38a89db7d4375bb4278bdc52cefa94d8e39                             

export const FACTORY_ADDRESS = '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73'

export const INIT_CODE_HASH = '0x00fb7f630766e6a796048ea87d01acd3068e8ff67d078148a3fa3f4a84f69bd5'

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const FEES_NUMERATOR = JSBI.BigInt(9975)
export const FEES_DENOMINATOR = JSBI.BigInt(10000)

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256'
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')
}
